(function () {
  // A box may be a product variant or a separate cart line. Always compare
  // totals for the same selection; never keep another variant's crossed price.
  function updateProductPrice(root, selected) {
    if (!root) return;
    if (!selected) {
      var selector = root.querySelector('[data-variant-select]');
      selected = selector ? selector.options[selector.selectedIndex] : null;
    }
    var source = selected ? selected.dataset : root.dataset;
    var baseCents = Number(source.priceCents);
    var previousCents = Number(source.compareAtPriceCents || 0);
    if (!Number.isFinite(baseCents) || baseCents < 0) return;

    var addonCents = 0;
    var boxToggle = root.querySelector('[data-box-toggle]');
    if (root.dataset.motorcycleBoxAddon && boxToggle && boxToggle.checked && !boxToggle.disabled) {
      var configuredAddon = Number(root.dataset.boxAddonPriceCents);
      if (Number.isFinite(configuredAddon) && configuredAddon > 0) addonCents = configuredAddon;
    }
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency', currency: root.dataset.productCurrency || 'EUR'
    });
    var price = root.querySelector('[data-product-price]');
    if (price) {
      price.textContent = addonCents ? formatter.format((baseCents + addonCents) / 100) :
        source.price || formatter.format(baseCents / 100);
    }
    var compare = root.querySelector('[data-product-compare-price]');
    if (compare) {
      var hasReduction = Number.isFinite(previousCents) && previousCents > baseCents;
      compare.hidden = !hasReduction;
      compare.textContent = hasReduction ? (addonCents ? formatter.format((previousCents + addonCents) / 100) :
        source.compareAtPrice || formatter.format(previousCents / 100)) : '';
    }
  }
  window.CasituProductPrice = {refresh: updateProductPrice};

  function setMenu(open) {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');

    if (!toggle || !menu) return;

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    menu.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.carouselReady === 'true') return;

    var track = carousel.querySelector('[data-carousel-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]')) : [];
    var previous = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var current = carousel.querySelector('[data-carousel-current]');
    var thumbnails = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-thumb]'));
    var animationFrame = null;
    var dragEnabled = carousel.hasAttribute('data-drag-carousel');
    var pointerDragging = false;
    var pointerId = null;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;

    if (!track || slides.length < 2) return;

    function getStep() {
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function getActiveIndex() {
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateCarousel() {
      var activeIndex = getActiveIndex();
      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      thumbnails.forEach(function (thumbnail, index) {
        var isActive = index === activeIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function moveCarousel(direction) {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    }

    function finishPointerDrag() {
      if (!pointerDragging) return;

      pointerDragging = false;
      track.classList.remove('is-dragging');
      track.style.removeProperty('scroll-behavior');
      track.style.removeProperty('scroll-snap-type');

      var activeIndex = getActiveIndex();
      track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });

      if (dragMoved) {
        carousel.dataset.dragged = 'true';
        window.setTimeout(function () {
          delete carousel.dataset.dragged;
        }, 0);
      }
    }

    if (previous) previous.addEventListener('click', function () { moveCarousel(-1); });
    if (next) next.addEventListener('click', function () { moveCarousel(1); });
    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        var index = Number(thumbnail.dataset.carouselThumb);
        if (!Number.isInteger(index) || !slides[index]) return;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', function () {
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(updateCarousel);
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveCarousel(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveCarousel(1);
      }
    });

    if (dragEnabled) {
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        pointerDragging = true;
        pointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        dragMoved = false;
        track.classList.add('is-dragging');
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        track.setPointerCapture(pointerId);
      });

      track.addEventListener('pointermove', function (event) {
        if (!pointerDragging || event.pointerId !== pointerId) return;

        var distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 5) dragMoved = true;
        track.scrollLeft = dragStartScroll - distance;
        if (dragMoved) event.preventDefault();
      });

      track.addEventListener('pointerup', finishPointerDrag);
      track.addEventListener('pointercancel', finishPointerDrag);
      track.addEventListener('lostpointercapture', finishPointerDrag);
      track.addEventListener('click', function (event) {
        if (carousel.dataset.dragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    window.addEventListener('resize', updateCarousel);
    window.addEventListener('load', updateCarousel);
    carousel.dataset.carouselReady = 'true';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(updateCarousel);
    });
  }

  function initCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  function updateBoxCustomizer(toggle, changeVariant) {
    if (!toggle) return;

    var customizer = toggle.closest('[data-box-customizer]');
    var productSection = toggle.closest('[data-product-form]');
    var details = customizer ? customizer.querySelector('[data-box-details]') : null;
    var variantSelect = productSection ? productSection.querySelector('[data-box-variant-select]') : null;
    var enabled = toggle.checked;

    toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
    if (details) details.hidden = !enabled;
    if (customizer) {
      customizer.querySelectorAll('[data-box-field]').forEach(function (field) {
        field.disabled = !enabled;
      });
      updateBoxMode(customizer);
    }

    if (changeVariant && variantSelect) {
      variantSelect.value = enabled ? toggle.dataset.boxVariant : toggle.dataset.baseVariant;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateBoxMode(customizer) {
    if (!customizer) return;

    var selectedMode = customizer.querySelector('[data-box-mode]:checked');
    if (!selectedMode) return;

    var toggle = customizer.querySelector('[data-box-toggle]');
    var boxEnabled = toggle ? toggle.checked : false;
    var customSelected = selectedMode.dataset.boxMode === 'custom';
    var defaultPanel = customizer.querySelector('[data-box-default-panel]');
    var customPanel = customizer.querySelector('[data-box-custom-panel]');

    customizer.querySelectorAll('[data-box-mode]').forEach(function (mode) {
      var choice = mode.closest('.product-box-mode__choice');
      if (choice) choice.classList.toggle('is-selected', mode.checked);
    });

    if (defaultPanel) defaultPanel.hidden = customSelected;
    if (customPanel) {
      customPanel.hidden = !customSelected;
      customPanel.querySelectorAll('[data-box-field]').forEach(function (field) {
        field.disabled = !boxEnabled || !customSelected;
      });
    }
  }

  function initBoxCustomizers(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-box-toggle]').forEach(function (toggle) {
      updateBoxCustomizer(toggle, false);
    });
  }

  initCarousels(document);
  initBoxCustomizers(document);
  document.addEventListener('shopify:section:load', function (event) {
    initCarousels(event.target);
    initBoxCustomizers(event.target);
  });

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (quantityButton) {
      var quantityWrap = quantityButton.closest('.product-form__quantity-wrap');
      var quantityInput = quantityWrap ? quantityWrap.querySelector('input[name="quantity"]') : null;
      if (!quantityInput) return;

      if (quantityButton.hasAttribute('data-quantity-plus')) {
        quantityInput.stepUp();
      } else {
        quantityInput.stepDown();
        if (Number(quantityInput.value) < 1) quantityInput.value = '1';
      }
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }

    if (event.target.closest('[data-mobile-menu] a')) {
      setMenu(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });

  document.addEventListener('change', function (event) {
    var boxToggle = event.target.closest('[data-box-toggle]');
    if (boxToggle) {
      updateBoxCustomizer(boxToggle, true);
      return;
    }

    var boxMode = event.target.closest('[data-box-mode]');
    if (boxMode) {
      updateBoxMode(boxMode.closest('[data-box-customizer]'));
      return;
    }

    var variantSelect = event.target.closest('[data-variant-select]');
    if (variantSelect) {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var form = variantSelect.closest('[data-product-form]');
      var submit = form ? form.querySelector('[data-product-submit]') : null;

      updateProductPrice(form, selected);
      var availability = form ? form.querySelector('[data-product-availability]') : null;
      if (availability) availability.textContent = selected.dataset.available === 'true' ? 'Disponible por encargo' : 'Agotado';
      if (submit) {
        var available = selected.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableText : submit.dataset.soldOutText;
      }

      if (selected.value && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url.toString());
      }
      return;
    }

    var fileInput = event.target.closest('[data-file-input]');
    if (fileInput) {
      var status = document.querySelector('[data-file-status="' + fileInput.id + '"]');
      if (status) {
        status.textContent = fileInput.files.length ? fileInput.files[0].name : 'Ningún archivo seleccionado';
      }
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 900) setMenu(false);
  });
})();
